import { useState } from "react";
import { motion } from "framer-motion";
import { Globe } from "lucide-react";
import { getVoiceLang, setVoiceLang } from "@/utils/voicePref";
import { toast } from "sonner";

export const VoiceToggleButton = () => {
  const [lang, setLang] = useState(getVoiceLang());

  const toggle = () => {
    const next = lang === "en-US" ? "id-ID" : "en-US";
    setVoiceLang(next);
    setLang(next);
    // Demo the chosen voice
    if ("speechSynthesis" in window) {
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance(next === "id-ID" ? "Hello, this is Indonesian voice" : "Hello, this is English voice");
      u.lang = next;
      u.rate = 0.85;
      u.volume = 1.0;
      window.speechSynthesis.speak(u);
    }
    toast.success(next === "id-ID" ? "Suara: Bahasa Indonesia 🇮🇩" : "Voice: English 🇺🇸", { duration: 1800 });
  };

  const flag = lang === "id-ID" ? "🇮🇩" : "🇺🇸";
  const code = lang === "id-ID" ? "ID" : "EN";

  return (
    <motion.button
      data-testid="voice-toggle-btn"
      onClick={toggle}
      title={`Ganti suara TTS — sekarang: ${lang}`}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
      className="fixed top-3 right-28 sm:right-36 z-50 glass-card-strong rounded-full px-2.5 py-2 sm:px-3 sm:py-2.5 border-2 border-gold/40 hover:border-gold/80 text-gold shadow-lg hover:shadow-gold/30 transition-all flex items-center gap-1.5"
      aria-label="Ganti bahasa suara"
    >
      <Globe className="w-4 h-4 sm:w-5 sm:h-5" strokeWidth={2.5} />
      <span className="text-xs sm:text-sm font-bold tracking-wide">{flag} {code}</span>
    </motion.button>
  );
};

export default VoiceToggleButton;
